// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/catalog/resources/enums.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "squareup.connect.v2.merchant_catalog.resources";
/** @desc The type of a CatalogItem. Connect V2 only allows the creation of `REGULAR` or `APPOINTMENTS_SERVICE` items. */
export var CatalogItemProductType;
(function (CatalogItemProductType) {
    /** REGULAR - @desc An ordinary item. */
    CatalogItemProductType[CatalogItemProductType["REGULAR"] = 0] = "REGULAR";
    /** GIFT_CARD - @desc A Square gift card. */
    CatalogItemProductType[CatalogItemProductType["GIFT_CARD"] = 1] = "GIFT_CARD";
    /** APPOINTMENTS_SERVICE - @desc A service that can be booked using the Square Appointments app. */
    CatalogItemProductType[CatalogItemProductType["APPOINTMENTS_SERVICE"] = 2] = "APPOINTMENTS_SERVICE";
    /** CLASS_TICKET - @desc A class ticket that can be sold using the Square Appointments app. */
    CatalogItemProductType[CatalogItemProductType["CLASS_TICKET"] = 5] = "CLASS_TICKET";
    /** FOOD_AND_BEV - @desc A food or beverage item that can be sold by restaurants and other food venues. */
    CatalogItemProductType[CatalogItemProductType["FOOD_AND_BEV"] = 6] = "FOOD_AND_BEV";
    /** EVENT - @desc An event which tickets can be sold for, including location, address, and times. */
    CatalogItemProductType[CatalogItemProductType["EVENT"] = 7] = "EVENT";
    /** DIGITAL - @desc A digital item like an ebook or song. */
    CatalogItemProductType[CatalogItemProductType["DIGITAL"] = 8] = "DIGITAL";
    /** DONATION - @desc A donation which site visitors can send for any cause. */
    CatalogItemProductType[CatalogItemProductType["DONATION"] = 9] = "DONATION";
    /** MEMBERSHIP - @desc Membership dues and registration fees for clubs and classes. */
    CatalogItemProductType[CatalogItemProductType["MEMBERSHIP"] = 10] = "MEMBERSHIP";
    /** CREDIT_PACKAGE - @desc A package of credits that can be sold using the Square Appointments app. */
    CatalogItemProductType[CatalogItemProductType["CREDIT_PACKAGE"] = 11] = "CREDIT_PACKAGE";
    /** COMBO - @desc A composition item containing configurable components that must be selected when building the combo at the time of sale. */
    CatalogItemProductType[CatalogItemProductType["COMBO"] = 13] = "COMBO";
    /** LEGACY_SQUARE_ONLINE_SERVICE - @desc A legacy Square Online service that is manually fulfilled. This corresponds to the `Other` item type displayed in the Square Seller Dashboard and Square POS apps. */
    CatalogItemProductType[CatalogItemProductType["LEGACY_SQUARE_ONLINE_SERVICE"] = 14] = "LEGACY_SQUARE_ONLINE_SERVICE";
    /** LEGACY_SQUARE_ONLINE_MEMBERSHIP - @desc A legacy Square Online membership that is manually fulfilled. This corresponds to the `Membership` item type displayed in the Square Seller Dashboard and Square POS apps. */
    CatalogItemProductType[CatalogItemProductType["LEGACY_SQUARE_ONLINE_MEMBERSHIP"] = 15] = "LEGACY_SQUARE_ONLINE_MEMBERSHIP";
    /** APPOINTMENTS_MEMBERSHIP - @desc An item to stores merchandising information for appointments fitness membership */
    CatalogItemProductType[CatalogItemProductType["APPOINTMENTS_MEMBERSHIP"] = 16] = "APPOINTMENTS_MEMBERSHIP";
    CatalogItemProductType[CatalogItemProductType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogItemProductType || (CatalogItemProductType = {}));
/** @desc Obsolete enumeration describing [CatalogItem](entity:CatalogItem) visibility. Use PRIVATE for all items. */
export var CatalogVisibility;
(function (CatalogVisibility) {
    /** PUBLIC - @desc Makes the item visible in the Square Point of Sale app and Square Market. Obsolete. */
    CatalogVisibility[CatalogVisibility["PUBLIC"] = 0] = "PUBLIC";
    /** PRIVATE - @desc Makes the item visible in the Square Point of Sale app only. */
    CatalogVisibility[CatalogVisibility["PRIVATE"] = 1] = "PRIVATE";
    /** PUBLIC_ONLY - @desc Makes the item visible in Square Market but hides it in the Square Point of Sale app. Obsolete. */
    CatalogVisibility[CatalogVisibility["PUBLIC_ONLY"] = 2] = "PUBLIC_ONLY";
    CatalogVisibility[CatalogVisibility["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogVisibility || (CatalogVisibility = {}));
/** @desc Indicates the type of a category. */
export var CatalogCategoryType;
(function (CatalogCategoryType) {
    CatalogCategoryType[CatalogCategoryType["CATALOG_CATEGORY_TYPE_DO_NOT_USE"] = 0] = "CATALOG_CATEGORY_TYPE_DO_NOT_USE";
    /** REGULAR_CATEGORY - @desc The regular category. */
    CatalogCategoryType[CatalogCategoryType["REGULAR_CATEGORY"] = 1] = "REGULAR_CATEGORY";
    /** MENU_CATEGORY - @desc The menu category. */
    CatalogCategoryType[CatalogCategoryType["MENU_CATEGORY"] = 2] = "MENU_CATEGORY";
    /** KITCHEN_CATEGORY - @desc Kitchen categories are used by KDS (Kitchen Display System) to route items to specific clients */
    CatalogCategoryType[CatalogCategoryType["KITCHEN_CATEGORY"] = 3] = "KITCHEN_CATEGORY";
    CatalogCategoryType[CatalogCategoryType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogCategoryType || (CatalogCategoryType = {}));
/** @desc Indicates whether Square should alert the merchant when the inventory quantity of a CatalogItemVariation is low. */
export var InventoryAlertType;
(function (InventoryAlertType) {
    InventoryAlertType[InventoryAlertType["INVENTORY_ALERT_TYPE_DO_NOT_USE"] = 0] = "INVENTORY_ALERT_TYPE_DO_NOT_USE";
    /** NONE - @desc The variation does not display an alert. */
    InventoryAlertType[InventoryAlertType["NONE"] = 1] = "NONE";
    /** LOW_QUANTITY - @desc The variation generates an alert when its quantity is low. */
    InventoryAlertType[InventoryAlertType["LOW_QUANTITY"] = 2] = "LOW_QUANTITY";
    InventoryAlertType[InventoryAlertType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(InventoryAlertType || (InventoryAlertType = {}));
/** @desc Indicates whether the price of a CatalogItemVariation should be entered manually at the time of sale. */
export var CatalogPricingType;
(function (CatalogPricingType) {
    /** FIXED_PRICING - @desc The catalog item variation's price is fixed. */
    CatalogPricingType[CatalogPricingType["FIXED_PRICING"] = 0] = "FIXED_PRICING";
    /** VARIABLE_PRICING - @desc The catalog item variation's price is entered at the time of sale. */
    CatalogPricingType[CatalogPricingType["VARIABLE_PRICING"] = 1] = "VARIABLE_PRICING";
    CatalogPricingType[CatalogPricingType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogPricingType || (CatalogPricingType = {}));
/** @desc When to calculate the taxes due on a cart. */
export var TaxCalculationPhase;
(function (TaxCalculationPhase) {
    /** TAX_SUBTOTAL_PHASE - @desc The fee is calculated based on the payment's subtotal. */
    TaxCalculationPhase[TaxCalculationPhase["TAX_SUBTOTAL_PHASE"] = 2] = "TAX_SUBTOTAL_PHASE";
    /** TAX_TOTAL_PHASE - @desc The fee is calculated based on the payment's total. */
    TaxCalculationPhase[TaxCalculationPhase["TAX_TOTAL_PHASE"] = 3] = "TAX_TOTAL_PHASE";
    TaxCalculationPhase[TaxCalculationPhase["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TaxCalculationPhase || (TaxCalculationPhase = {}));
/** @desc Whether to the tax amount should be additional to or included in the CatalogItem price. */
export var TaxInclusionType;
(function (TaxInclusionType) {
    /**
     * ADDITIVE - --
     * @desc The tax is an additive tax. The tax amount is added on top of the
     * CatalogItemVariation price. For example, a $1.00 item with a 10% additive
     * tax would have a total cost to the buyer of $1.10.
     * --
     */
    TaxInclusionType[TaxInclusionType["ADDITIVE"] = 0] = "ADDITIVE";
    /**
     * INCLUSIVE - --
     * @desc The tax is an inclusive tax. The tax amount is included in the
     * CatalogItemVariation price. For example, a $1.00 item with a 10% inclusive
     * tax would have a total cost to the buyer of $1.00, with $0.91 (91 cents) of
     * that total being the cost of the item and $0.09 (9 cents) being tax.
     * --
     */
    TaxInclusionType[TaxInclusionType["INCLUSIVE"] = 1] = "INCLUSIVE";
    TaxInclusionType[TaxInclusionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TaxInclusionType || (TaxInclusionType = {}));
/** @desc How to apply a CatalogDiscount to a CatalogItem. */
export var CatalogDiscountType;
(function (CatalogDiscountType) {
    /** FIXED_PERCENTAGE - @desc Apply the discount as a fixed percentage (e.g., 5%) off the item price. */
    CatalogDiscountType[CatalogDiscountType["FIXED_PERCENTAGE"] = 0] = "FIXED_PERCENTAGE";
    /** FIXED_AMOUNT - @desc Apply the discount as a fixed amount (e.g., $1.00) off the item price. */
    CatalogDiscountType[CatalogDiscountType["FIXED_AMOUNT"] = 1] = "FIXED_AMOUNT";
    /** VARIABLE_PERCENTAGE - @desc Apply the discount as a variable percentage off the item price. The percentage will be specified at the time of sale. */
    CatalogDiscountType[CatalogDiscountType["VARIABLE_PERCENTAGE"] = 2] = "VARIABLE_PERCENTAGE";
    /** VARIABLE_AMOUNT - @desc Apply the discount as a variable amount off the item price. The amount will be specified at the time of sale. */
    CatalogDiscountType[CatalogDiscountType["VARIABLE_AMOUNT"] = 3] = "VARIABLE_AMOUNT";
    CatalogDiscountType[CatalogDiscountType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogDiscountType || (CatalogDiscountType = {}));
export var CatalogDiscountApplicationMethod;
(function (CatalogDiscountApplicationMethod) {
    /** MANUALLY_APPLIED - @desc A traditional discount, applied by the cashier at the time of sale. */
    CatalogDiscountApplicationMethod[CatalogDiscountApplicationMethod["MANUALLY_APPLIED"] = 1] = "MANUALLY_APPLIED";
    /** COMP - @desc A comp, applied to [CatalogItem](entity:CatalogItem)s already in the cart via the comp UI. */
    CatalogDiscountApplicationMethod[CatalogDiscountApplicationMethod["COMP"] = 2] = "COMP";
    CatalogDiscountApplicationMethod[CatalogDiscountApplicationMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogDiscountApplicationMethod || (CatalogDiscountApplicationMethod = {}));
export var CatalogDiscountModifyTaxBasis;
(function (CatalogDiscountModifyTaxBasis) {
    /** MODIFY_TAX_BASIS - @desc Application of the discount will modify the tax basis. */
    CatalogDiscountModifyTaxBasis[CatalogDiscountModifyTaxBasis["MODIFY_TAX_BASIS"] = 0] = "MODIFY_TAX_BASIS";
    /** DO_NOT_MODIFY_TAX_BASIS - @desc Application of the discount will not modify the tax basis. */
    CatalogDiscountModifyTaxBasis[CatalogDiscountModifyTaxBasis["DO_NOT_MODIFY_TAX_BASIS"] = 1] = "DO_NOT_MODIFY_TAX_BASIS";
    CatalogDiscountModifyTaxBasis[CatalogDiscountModifyTaxBasis["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogDiscountModifyTaxBasis || (CatalogDiscountModifyTaxBasis = {}));
/**
 * --
 * @desc How to apply a CatalogSalePrice to a CatalogItemVariation. the two allowed types are:
 *
 * - SALE_PRICE_TYPE_FIXED_AMOUNT: This type specifies that the item has a sale price that's a predetermined
 * flat amount replacing its original price.
 *
 * - SALE_PRICE_TYPE_FIXED_PERCENTAGE: This type indicates that the item's sale price is a specific percentage
 * off its original price. For instance, a 20% sale price would mean that the item is being
 * sold at 80% of its original price.
 * --
 */
export var CatalogSalePriceType;
(function (CatalogSalePriceType) {
    CatalogSalePriceType[CatalogSalePriceType["SALE_PRICE_TYPE_DO_NOT_USE"] = 0] = "SALE_PRICE_TYPE_DO_NOT_USE";
    /** SALE_PRICE_TYPE_FIXED_AMOUNT - @desc Apply the sale price as a fixed amount (e.g., $5.00) overriding the base price. */
    CatalogSalePriceType[CatalogSalePriceType["SALE_PRICE_TYPE_FIXED_AMOUNT"] = 1] = "SALE_PRICE_TYPE_FIXED_AMOUNT";
    /** SALE_PRICE_TYPE_FIXED_PERCENTAGE - @desc Apply the sale price as a fixed percentage (e.g., 5%) off the item price. */
    CatalogSalePriceType[CatalogSalePriceType["SALE_PRICE_TYPE_FIXED_PERCENTAGE"] = 2] = "SALE_PRICE_TYPE_FIXED_PERCENTAGE";
    CatalogSalePriceType[CatalogSalePriceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogSalePriceType || (CatalogSalePriceType = {}));
/** @desc Indicates whether a CatalogModifierList supports multiple selections. */
export var CatalogModifierListSelectionType;
(function (CatalogModifierListSelectionType) {
    /**
     * SINGLE - --
     * @desc Indicates that a CatalogModifierList allows only a
     * single CatalogModifier to be selected.
     * --
     */
    CatalogModifierListSelectionType[CatalogModifierListSelectionType["SINGLE"] = 0] = "SINGLE";
    /**
     * MULTIPLE - --
     * @desc Indicates that a CatalogModifierList allows multiple
     * CatalogModifier to be selected.
     * --
     */
    CatalogModifierListSelectionType[CatalogModifierListSelectionType["MULTIPLE"] = 1] = "MULTIPLE";
    CatalogModifierListSelectionType[CatalogModifierListSelectionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogModifierListSelectionType || (CatalogModifierListSelectionType = {}));
/** @desc Indicates how a CatalogPricingRule can be combined with other pricing rules. */
export var AggregationStrategy;
(function (AggregationStrategy) {
    /**
     * UNKNOWN - --
     * @desc The pricing rule has an aggregation strategy that cannot be represented with the current
     * version of the API.
     * --
     */
    AggregationStrategy[AggregationStrategy["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * STACKABLE - --
     * @desc The pricing rule can be combined with any other eligible pricing rules.
     * --
     */
    AggregationStrategy[AggregationStrategy["STACKABLE"] = 2] = "STACKABLE";
    /** EXCLUSIVE - @desc The pricing rule cannot be combined with other EXCLUSIVE pricing rules. */
    AggregationStrategy[AggregationStrategy["EXCLUSIVE"] = 3] = "EXCLUSIVE";
    AggregationStrategy[AggregationStrategy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AggregationStrategy || (AggregationStrategy = {}));
/**
 * --
 * @desc Possible types of CatalogObjects returned from the catalog, each
 * containing type-specific properties in the `*_data` field corresponding to the specified object type.
 * --
 */
export var CatalogObjectType;
(function (CatalogObjectType) {
    CatalogObjectType[CatalogObjectType["CATALOG_OBJECT_TYPE_DO_NOT_USE"] = 0] = "CATALOG_OBJECT_TYPE_DO_NOT_USE";
    /**
     * ITEM - --
     * @desc The `CatalogObject` instance is of the [CatalogItem](entity:CatalogItem) type and represents an item. The item-specific data
     * must be set on the `item_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["ITEM"] = 1] = "ITEM";
    /**
     * IMAGE - --
     * @desc The `CatalogObject` instance is of the [CatalogImage](entity:CatalogImage) type and represents an image. The image-specific data
     * must be set on the `image_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["IMAGE"] = 2] = "IMAGE";
    /**
     * PAGE_TILE - --
     * @desc The `CatalogObject` instance is of the [CatalogPageTile](entity:CatalogPageTile) type and represents an page tile. The page tile-specific data
     * must be set on the `page_tile_data` field.
     */
    CatalogObjectType[CatalogObjectType["PAGE_TILE"] = 3] = "PAGE_TILE";
    /**
     * CATEGORY - --
     * @desc The `CatalogObject` instance is of the [CatalogCategory](entity:CatalogCategory) type and represents a category. The category-specific data
     * must be set on the `category_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["CATEGORY"] = 4] = "CATEGORY";
    /**
     * ITEM_VARIATION - --
     * @desc The `CatalogObject` instance is of the  [CatalogItemVariation](entity:CatalogItemVariation) type and represents an item variation, also referred to as variation.
     * The item variation-specific data must be set on the `item_variation_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["ITEM_VARIATION"] = 5] = "ITEM_VARIATION";
    /**
     * TAX - --
     * @desc The `CatalogObject` instance is of the [CatalogTax](entity:CatalogTax) type and represents a tax. The tax-specific data
     * must be set on the `tax_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["TAX"] = 6] = "TAX";
    /**
     * PLACEHOLDER - --
     * @desc The `CatalogObject` instance is of the [CatalogPlaceholder](entity:CatalogPlaceholder) type and represents a placeholder. The placeholder-specific data
     * must be set on the `placeholder_data` field.
     */
    CatalogObjectType[CatalogObjectType["PLACEHOLDER"] = 7] = "PLACEHOLDER";
    /**
     * DISCOUNT - --
     * @desc The `CatalogObject` instance is of the [CatalogDiscount](entity:CatalogDiscount) type and represents a discount. The discount-specific data
     * must be set on the `discount_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["DISCOUNT"] = 8] = "DISCOUNT";
    /**
     * MODIFIER_LIST - --
     * @desc The `CatalogObject` instance is of the [CatalogModifierList](entity:CatalogModifierList) type and represents a modifier list.
     * The modifier-list-specific data must be set on the `modifier_list_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["MODIFIER_LIST"] = 10] = "MODIFIER_LIST";
    /**
     * MODIFIER - --
     * @desc The `CatalogObject` instance is of the [CatalogModifier](entity:CatalogModifier) type and represents a modifier. The modifier-specific data
     * must be set on the `modifier_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["MODIFIER"] = 12] = "MODIFIER";
    /**
     * DINING_OPTION - --
     * @desc The `CatalogObject` instance is of the [CatalogDiningOption](entity:CatalogDiningOption) type and represents a dining option. The dining-option-specific data
     * will be stored in the `dining_option_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["DINING_OPTION"] = 18] = "DINING_OPTION";
    /**
     * TAX_EXEMPTION - --
     * @desc The `CatalogObject` instance is of the [CatalogTaxExemption](entity:CatalogTaxExemption) type and represents a tax exemption rule. The rule-specific data
     * must be set on the `tax_exemption_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["TAX_EXEMPTION"] = 19] = "TAX_EXEMPTION";
    /**
     * CONFIGURATION - --
     * @desc The `CatalogObject` instance is of the [CatalogConfiguration](entity:CatalogConfiguration) type and represents a configuration. The configuration-specific data
     * must be set on the `configuration_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["CONFIGURATION"] = 20] = "CONFIGURATION";
    /**
     * TICKET_GROUP - --
     * @desc The `CatalogObject` instance is of the [CatalogTicketGroup](entity:CatalogTicketGroup) type and represents
     * a ticket group. The ticket-group-specific data must be set on the `ticket_group_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["TICKET_GROUP"] = 22] = "TICKET_GROUP";
    /**
     * TICKET_TEMPLATE - --
     * @desc The `CatalogObject` instance is of the [CatalogTicketTemplate](entity:CatalogTicketTemplate) type and
     * represents a ticket template. The ticket-template-specific data must be set on the `ticket_template_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["TICKET_TEMPLATE"] = 23] = "TICKET_TEMPLATE";
    /**
     * PAGE - --
     * @desc The `CatalogObject` instance is of the [CatalogPage](entity:CatalogPage) type and represents a page. The page-specific data
     * must be set on the `page_data` field.
     */
    CatalogObjectType[CatalogObjectType["PAGE"] = 21] = "PAGE";
    /**
     * MENU - --
     * @desc The `CatalogObject` instance is of the [CatalogMenu](entity:CatalogMenu) type and represents a menu. The menu-specific data
     * must be set on the `menu_data` field.
     */
    CatalogObjectType[CatalogObjectType["MENU"] = 26] = "MENU";
    /**
     * TAG - --
     * @desc The `CatalogObject` instance is of the [CatalogPlaceholder](entity:CatalogPlaceholder) type and represents an page tile. The placeholder-specific data
     * must be set on the `placeholder_tile_data` field.
     */
    CatalogObjectType[CatalogObjectType["TAG"] = 27] = "TAG";
    /**
     * FLOOR_PLAN - --
     * @desc The `CatalogObject` instance is of the [CatalogFloorPlan](entity:CatalogFloorPlan) type and represents a
     * restaurant floor plan. The floor-plan-specific data must be set on the `floor_plan_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["FLOOR_PLAN"] = 28] = "FLOOR_PLAN";
    /**
     * FLOOR_PLAN_TILE - --
     * @desc The `CatalogObject` instance is of the [CatalogFloorPlanTile](entity:CatalogFloorPlanTile) type and
     * represents a restaurant floor plan tile. The floor-plan-tile-specific data must be set on the `floor_plan_tile_data`
     * field.
     * --
     */
    CatalogObjectType[CatalogObjectType["FLOOR_PLAN_TILE"] = 29] = "FLOOR_PLAN_TILE";
    /**
     * VOID_REASON - --
     * @desc The `CatalogObject` instance is of the [CatalogVoidReason](entity:CatalogVoidReason) type and represents a
     * void reason. The void-reason-specific data will be stored in the `void_reason_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["VOID_REASON"] = 24] = "VOID_REASON";
    /**
     * FAVORITES_LIST_POSITION - --
     * @desc The `CatalogObject` instance is of the [CatalogFavoritesListPosition](entity:CatalogFavoritesListPosition) type
     * and represents a Retail favorites item. The favorites-list-position-specific data will be stored in the
     * `favorites_list_position_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["FAVORITES_LIST_POSITION"] = 30] = "FAVORITES_LIST_POSITION";
    /**
     * MENU_GROUP - --
     * @desc The `CatalogObject` instance is of the [CatalogMenuGroup](entity:CatalogMenuGroup) type and represents a
     * menu group. The menu group-specific data must be set on the `menu_group_data` field.
     */
    CatalogObjectType[CatalogObjectType["MENU_GROUP"] = 31] = "MENU_GROUP";
    /**
     * ITEM_VARIATION_VENDOR_INFO - --
     * @desc The `CatalogObject` instance is of the [CatalogItemVariationVendorInfo](entity:CatalogItemVariationVendorInfo)
     * type and represents a relationship between an ItemVariation and a Vendor. The item-variation-vendor-info-specific data
     * will be stored in the `item_variation_vendor_info_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["ITEM_VARIATION_VENDOR_INFO"] = 25] = "ITEM_VARIATION_VENDOR_INFO";
    /**
     * SERVICE_CHARGE - --
     * @desc The `CatalogObject` instance is of the [CatalogServiceCharge](entity:CatalogServiceCharge) type and represents a service charge. The service-charge-specific data
     * will be stored in the `service_charge_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["SERVICE_CHARGE"] = 32] = "SERVICE_CHARGE";
    /**
     * PRICING_RULE - --
     * @desc The `CatalogObject` instance is of the [CatalogPricingRule](entity:CatalogPricingRule) type and represents a pricing rule. The pricing-rule-specific data
     * must be set on the `pricing_rule_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["PRICING_RULE"] = 33] = "PRICING_RULE";
    /**
     * PRODUCT_SET - --
     * @desc The `CatalogObject` instance is of the [CatalogProductSet](entity:CatalogProductSet) type and represents a product set.
     * The product-set-specific data will be stored in the `product_set_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["PRODUCT_SET"] = 34] = "PRODUCT_SET";
    /**
     * TIME_PERIOD - --
     * @desc The `CatalogObject` instance is of the [CatalogTimePeriod](entity:CatalogTimePeriod) type and represents a time period.
     * The time-period-specific data must be set on the `time_period_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["TIME_PERIOD"] = 35] = "TIME_PERIOD";
    /**
     * MEASUREMENT_UNIT - --
     * @desc The `CatalogObject` instance is of the [CatalogMeasurementUnit](entity:CatalogMeasurementUnit) type and represents a measurement unit specifying the unit of
     * measure and precision in which an item variation is sold. The measurement-unit-specific data must set on the `measurement_unit_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["MEASUREMENT_UNIT"] = 37] = "MEASUREMENT_UNIT";
    /**
     * SUBSCRIPTION_PLAN_VARIATION - --
     * @desc The `CatalogObject` instance is of the [CatalogSubscriptionPlan](entity:CatalogSubscriptionPlan) type and represents a subscription plan.
     * The subscription-plan-specific data must be stored on the `subscription_plan_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["SUBSCRIPTION_PLAN_VARIATION"] = 38] = "SUBSCRIPTION_PLAN_VARIATION";
    /**
     * ITEM_OPTION - --
     * @desc The `CatalogObject` instance is of the [CatalogItemOption](entity:CatalogItemOption) type and represents a list of options (such as a color or size of a T-shirt)
     * that can be assigned to item variations. The item-option-specific data must be on the `item_option_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["ITEM_OPTION"] = 39] = "ITEM_OPTION";
    /**
     * ITEM_OPTION_VAL - --
     * @desc The `CatalogObject` instance is of the [CatalogItemOptionValue](entity:CatalogItemOptionValue) type and represents a value associated with one or more item options.
     * For example, an item option of "Size" may have item option values such as "Small" or "Medium".
     * The item-option-value-specific data must be on the `item_option_value_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["ITEM_OPTION_VAL"] = 40] = "ITEM_OPTION_VAL";
    /**
     * CUSTOM_ATTRIBUTE_DEFINITION - --
     * @desc The `CatalogObject` instance is of the [CatalogCustomAttributeDefinition](entity:CatalogCustomAttributeDefinition) type and represents the definition of a custom attribute.
     * The custom-attribute-definition-specific data must be set on the `custom_attribute_definition_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["CUSTOM_ATTRIBUTE_DEFINITION"] = 41] = "CUSTOM_ATTRIBUTE_DEFINITION";
    /**
     * QUICK_AMOUNTS_SETTINGS - --
     * @desc The `CatalogObject` instance is of the [CatalogQuickAmountsSettings](entity:CatalogQuickAmountsSettings) type and represents settings to configure preset charges for quick payments at each location.
     * For example, a location may have a list of both AUTO and MANUAL quick amounts that are set to DISABLED.
     * The quick-amounts-settings-specific data must be set on the `quick_amounts_settings_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["QUICK_AMOUNTS_SETTINGS"] = 45] = "QUICK_AMOUNTS_SETTINGS";
    /** COMPONENT - @desc The `CatalogObject` instance is of the [CatalogComponent](entity:CatalogComponent) type and represents an inventory component. The component-specific data must set on the `component_data` field. */
    CatalogObjectType[CatalogObjectType["COMPONENT"] = 47] = "COMPONENT";
    /** COMPOSITION - @desc The `CatalogObject` instance is of the [CatalogComposition](entity:CatalogComposition) type and represents an inventory composition. The composition-specific data must be set on the `composition_data` field. */
    CatalogObjectType[CatalogObjectType["COMPOSITION"] = 48] = "COMPOSITION";
    /**
     * RESOURCE - --
     * @desc The `CatalogObject` instance is of the `CatalogResource` type and represents a resource necessary for performing a service.
     * E.g. a room required for a bikini wax, or a table for a massage. The resource-specific data must be set on the `resource_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["RESOURCE"] = 49] = "RESOURCE";
    /**
     * CHECKOUT_LINK - --
     * @desc The `CatalogObject` instance is of the [CatalogCheckoutLink](entity:CatalogCheckoutLink) type and represents an online checkout link.
     * The checkout-link-specific data must be set on the `checkout_link_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["CHECKOUT_LINK"] = 52] = "CHECKOUT_LINK";
    /**
     * ADDRESS - --
     * @desc The `CatalogObject` instance is of the [CatalogAddress](entity:CatalogAddress) type and represents a address. The address-specific data must be set on the `address_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["ADDRESS"] = 57] = "ADDRESS";
    /**
     * SUBSCRIPTION_PLAN - --
     * @desc The `CatalogObject` instance is of the [CatalogSubscriptionPlan](entity:CatalogSubscriptionPlan) type and represents a subscription plan.
     * The subscription plan specific data must be stored on the `subscription_plan_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["SUBSCRIPTION_PLAN"] = 59] = "SUBSCRIPTION_PLAN";
    /**
     * AVAILABILITY_PERIOD - --
     * @desc The `CatalogObject` instance is of the [CatalogAvailabilityPeriod](entity:CatalogAvailabilityPeriod) type and represents an availability period.
     * The availability period specific data must be stored on the `availability_period_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["AVAILABILITY_PERIOD"] = 61] = "AVAILABILITY_PERIOD";
    CatalogObjectType[CatalogObjectType["CREDIT_REDEMPTION_POLICY"] = 62] = "CREDIT_REDEMPTION_POLICY";
    /**
     * AGE_RESTRICTION - --
     * @desc The `CatalogObject` instance is of the [CatalogAgeRestriction](entity:CatalogAgeRestriction) type and represents the minimum buyer age.
     * The minimum buyer age specific data must be stored on the `minimum_buyer_age_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["AGE_RESTRICTION"] = 63] = "AGE_RESTRICTION";
    /**
     * SALE_PRICE - --
     * @desc The `CatalogObject` instance is of the [CatalogSalePrice](entity:CatalogSalePrice) type and represents a sale price. The sale price data
     * must be set on the `sale_price_data` field.`
     * --
     */
    CatalogObjectType[CatalogObjectType["SALE_PRICE"] = 65] = "SALE_PRICE";
    /**
     * TAX_CATEGORY - --
     * @desc The `CatalogObject` instance is of the [CatalogTaxCategory](entity:CatalogTaxCategory) type and represents a tax category.
     * The tax category type specific data must be stored on the `tax_category_data` field.
     * --
     */
    CatalogObjectType[CatalogObjectType["TAX_CATEGORY"] = 68] = "TAX_CATEGORY";
    CatalogObjectType[CatalogObjectType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogObjectType || (CatalogObjectType = {}));
/**
 * --
 * @desc Possible kinds of [CatalogItemOption](entity:CatalogItemOption)s returned from the Catalog.
 * --
 */
export var DEPRECATEDCatalogItemOptionType;
(function (DEPRECATEDCatalogItemOptionType) {
    DEPRECATEDCatalogItemOptionType[DEPRECATEDCatalogItemOptionType["DEPRECATED_ATTRIBUTE_TYPE_UNKNOWN"] = 0] = "DEPRECATED_ATTRIBUTE_TYPE_UNKNOWN";
    DEPRECATEDCatalogItemOptionType[DEPRECATEDCatalogItemOptionType["DEPRECATED_STRING_ENUM"] = 1] = "DEPRECATED_STRING_ENUM";
    DEPRECATEDCatalogItemOptionType[DEPRECATEDCatalogItemOptionType["DEPRECATED_COLOR_ENUM"] = 2] = "DEPRECATED_COLOR_ENUM";
    DEPRECATEDCatalogItemOptionType[DEPRECATEDCatalogItemOptionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DEPRECATEDCatalogItemOptionType || (DEPRECATEDCatalogItemOptionType = {}));
/**
 * --
 * @desc Type of a changed CatalogAttribute.
 * --
 */
export var CatalogAttributeType;
(function (CatalogAttributeType) {
    CatalogAttributeType[CatalogAttributeType["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** STRING - @desc Attribute has string value. */
    CatalogAttributeType[CatalogAttributeType["STRING"] = 1] = "STRING";
    /** INT - @desc Attribute has integer value. */
    CatalogAttributeType[CatalogAttributeType["INT"] = 2] = "INT";
    /** BOOL - @desc Attribute has boolean value. */
    CatalogAttributeType[CatalogAttributeType["BOOL"] = 3] = "BOOL";
    /** MONEY - @desc Attribute has money value. */
    CatalogAttributeType[CatalogAttributeType["MONEY"] = 4] = "MONEY";
    /** NESTED - @desc Attribute has nested values. It may be a list or an object. */
    CatalogAttributeType[CatalogAttributeType["NESTED"] = 5] = "NESTED";
    CatalogAttributeType[CatalogAttributeType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogAttributeType || (CatalogAttributeType = {}));
/**
 * --
 * @desc Indicates which products matched by a CatalogPricingRule
 * will be excluded if the pricing rule uses an exclude set.
 * --
 */
export var ExcludeStrategy;
(function (ExcludeStrategy) {
    ExcludeStrategy[ExcludeStrategy["EXCLUDE_STRATEGY_DO_NOT_USE"] = 0] = "EXCLUDE_STRATEGY_DO_NOT_USE";
    /**
     * LEAST_EXPENSIVE - --
     * @desc The least expensive matched products are excluded from the pricing. If
     * the pricing rule is set to exclude one product and multiple products in the
     * match set qualify as least expensive, then one will be excluded at random.
     *
     * Excluding the least expensive product gives the best discount value to the buyer.
     * --
     */
    ExcludeStrategy[ExcludeStrategy["LEAST_EXPENSIVE"] = 1] = "LEAST_EXPENSIVE";
    /**
     * MOST_EXPENSIVE - --
     * @desc The most expensive matched product is excluded from the pricing rule.
     * If multiple products have the same price and all qualify as least expensive,
     * one will be excluded at random.
     *
     * This guarantees that the most expensive product is purchased at full price.
     * --
     */
    ExcludeStrategy[ExcludeStrategy["MOST_EXPENSIVE"] = 2] = "MOST_EXPENSIVE";
    ExcludeStrategy[ExcludeStrategy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ExcludeStrategy || (ExcludeStrategy = {}));
/**
 * --
 * @desc Indicates if a PricingRule may be automatically applied, or if some other conditions must be met
 * --
 */
export var CatalogPricingRuleApplicationMode;
(function (CatalogPricingRuleApplicationMode) {
    CatalogPricingRuleApplicationMode[CatalogPricingRuleApplicationMode["PRICING_RULE_APPLICATION_MODE_DO_NOT_USE"] = 0] = "PRICING_RULE_APPLICATION_MODE_DO_NOT_USE";
    /** AUTOMATIC - @desc Pricing Rule is to be applied automatically */
    CatalogPricingRuleApplicationMode[CatalogPricingRuleApplicationMode["AUTOMATIC"] = 1] = "AUTOMATIC";
    /** ATTACHED - @desc Pricing Rule may only be applied given an associated Coupon or Loyalty Reward on the Order */
    CatalogPricingRuleApplicationMode[CatalogPricingRuleApplicationMode["ATTACHED"] = 2] = "ATTACHED";
    CatalogPricingRuleApplicationMode[CatalogPricingRuleApplicationMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogPricingRuleApplicationMode || (CatalogPricingRuleApplicationMode = {}));
/**
 * --
 * @desc Determines the scope at which the discounts created by the pricing rule
 * should be applied (i.e.- whole purchase or line item)
 * --
 */
export var DiscountTargetScope;
(function (DiscountTargetScope) {
    DiscountTargetScope[DiscountTargetScope["DISCOUNT_TARGET_SCOPE_DO_NOT_USE"] = 0] = "DISCOUNT_TARGET_SCOPE_DO_NOT_USE";
    /**
     * LINE_ITEM - --
     * @desc Discounts applied by this Pricing Rule should be applied to a cart's line items
     * --
     */
    DiscountTargetScope[DiscountTargetScope["LINE_ITEM"] = 1] = "LINE_ITEM";
    /**
     * WHOLE_PURCHASE - --
     * @desc Discounts applied by this Pricing Rule should be applied at the cart level
     * --
     */
    DiscountTargetScope[DiscountTargetScope["WHOLE_PURCHASE"] = 2] = "WHOLE_PURCHASE";
    DiscountTargetScope[DiscountTargetScope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DiscountTargetScope || (DiscountTargetScope = {}));
/**
 * --
 * @desc Determines the scope at which the service charges created by the pricing rule
 * should be applied (i.e.- whole purchase or line item).
 * --
 */
export var ServiceChargeTargetScope;
(function (ServiceChargeTargetScope) {
    ServiceChargeTargetScope[ServiceChargeTargetScope["SURCHARGE_TARGET_SCOPE_DO_NOT_USE"] = 0] = "SURCHARGE_TARGET_SCOPE_DO_NOT_USE";
    /**
     * SURCHARGE_TARGET_SCOPE_LINE_ITEM - --
     * @desc Service charges applied by this Pricing Rule should be applied to a cart's line items
     * --
     */
    ServiceChargeTargetScope[ServiceChargeTargetScope["SURCHARGE_TARGET_SCOPE_LINE_ITEM"] = 1] = "SURCHARGE_TARGET_SCOPE_LINE_ITEM";
    /**
     * SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE - --
     * @desc Service charges applied by this Pricing Rule should be applied at the cart level
     * --
     */
    ServiceChargeTargetScope[ServiceChargeTargetScope["SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE"] = 2] = "SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE";
    ServiceChargeTargetScope[ServiceChargeTargetScope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ServiceChargeTargetScope || (ServiceChargeTargetScope = {}));
/**
 * --
 * @desc Determines the type of a specific Quick Amount.
 * --
 */
export var CatalogQuickAmountType;
(function (CatalogQuickAmountType) {
    CatalogQuickAmountType[CatalogQuickAmountType["QUICK_AMOUNT_TYPE_DO_NOT_USE"] = 0] = "QUICK_AMOUNT_TYPE_DO_NOT_USE";
    /**
     * QUICK_AMOUNT_TYPE_MANUAL - --
     * @desc Quick Amount is created manually by the seller.
     * --
     */
    CatalogQuickAmountType[CatalogQuickAmountType["QUICK_AMOUNT_TYPE_MANUAL"] = 1] = "QUICK_AMOUNT_TYPE_MANUAL";
    /**
     * QUICK_AMOUNT_TYPE_AUTO - --
     * @desc Quick Amount is generated automatically by machine learning algorithms.
     * --
     */
    CatalogQuickAmountType[CatalogQuickAmountType["QUICK_AMOUNT_TYPE_AUTO"] = 2] = "QUICK_AMOUNT_TYPE_AUTO";
    CatalogQuickAmountType[CatalogQuickAmountType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogQuickAmountType || (CatalogQuickAmountType = {}));
/**
 * --
 * @desc Determines a seller's option on Quick Amounts feature.
 * --
 */
export var CatalogQuickAmountsSettingsOption;
(function (CatalogQuickAmountsSettingsOption) {
    CatalogQuickAmountsSettingsOption[CatalogQuickAmountsSettingsOption["QUICK_AMOUNTS_SETTINGS_OPTION_DO_NOT_USE"] = 0] = "QUICK_AMOUNTS_SETTINGS_OPTION_DO_NOT_USE";
    /**
     * DISABLED - --
     * @desc Option for seller to disable Quick Amounts.
     * --
     */
    CatalogQuickAmountsSettingsOption[CatalogQuickAmountsSettingsOption["DISABLED"] = 1] = "DISABLED";
    /**
     * MANUAL - --
     * @desc Option for seller to choose manually created Quick Amounts.
     * --
     */
    CatalogQuickAmountsSettingsOption[CatalogQuickAmountsSettingsOption["MANUAL"] = 2] = "MANUAL";
    /**
     * AUTO - --
     * @desc Option for seller to choose automatically created Quick Amounts.
     * --
     */
    CatalogQuickAmountsSettingsOption[CatalogQuickAmountsSettingsOption["AUTO"] = 3] = "AUTO";
    CatalogQuickAmountsSettingsOption[CatalogQuickAmountsSettingsOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogQuickAmountsSettingsOption || (CatalogQuickAmountsSettingsOption = {}));
/**
 * --
 * @desc Determines item visibility in Ecom (Online Store) and Online Checkout.
 * --
 */
export var EcomVisibility;
(function (EcomVisibility) {
    EcomVisibility[EcomVisibility["ECOM_VISIBILITY_DO_NOT_USE"] = 0] = "ECOM_VISIBILITY_DO_NOT_USE";
    /** UNINDEXED - @desc Item is not synced with Ecom (Weebly). This is the default state */
    EcomVisibility[EcomVisibility["UNINDEXED"] = 1] = "UNINDEXED";
    /** UNAVAILABLE - @desc Item is synced but is unavailable within Ecom (Weebly) and Online Checkout */
    EcomVisibility[EcomVisibility["UNAVAILABLE"] = 2] = "UNAVAILABLE";
    /** HIDDEN - @desc Option for seller to choose manually created Quick Amounts. */
    EcomVisibility[EcomVisibility["HIDDEN"] = 3] = "HIDDEN";
    /** VISIBLE - @desc Item is synced but available within Ecom (Weebly) and Online Checkout but is hidden from Ecom Store. */
    EcomVisibility[EcomVisibility["VISIBLE"] = 4] = "VISIBLE";
    EcomVisibility[EcomVisibility["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EcomVisibility || (EcomVisibility = {}));
/**
 * --
 * @desc Defines the values for the `archived_state` query expression
 * used in [SearchCatalogItems](api-endpoint:Catalog-SearchCatalogItems)
 * to return the archived, not archived or either type of catalog items.
 * --
 */
export var ArchivedState;
(function (ArchivedState) {
    ArchivedState[ArchivedState["ARCHIVED_STATE_DO_NOT_USE"] = 0] = "ARCHIVED_STATE_DO_NOT_USE";
    /** ARCHIVED_STATE_NOT_ARCHIVED - @desc Requested items are not archived with the `is_archived` attribute set to `false`. */
    ArchivedState[ArchivedState["ARCHIVED_STATE_NOT_ARCHIVED"] = 1] = "ARCHIVED_STATE_NOT_ARCHIVED";
    /** ARCHIVED_STATE_ARCHIVED - @desc Requested items are archived with the `is_archived` attribute set to `true`. */
    ArchivedState[ArchivedState["ARCHIVED_STATE_ARCHIVED"] = 2] = "ARCHIVED_STATE_ARCHIVED";
    /** ARCHIVED_STATE_ALL - @desc Requested items can be archived or not archived. */
    ArchivedState[ArchivedState["ARCHIVED_STATE_ALL"] = 3] = "ARCHIVED_STATE_ALL";
    ArchivedState[ArchivedState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ArchivedState || (ArchivedState = {}));
/**
 * --
 * @desc Determines service charge type
 * --
 */
export var CatalogServiceChargeType;
(function (CatalogServiceChargeType) {
    CatalogServiceChargeType[CatalogServiceChargeType["SERVICE_CHARGE_TYPE_DO_NOT_USE"] = 0] = "SERVICE_CHARGE_TYPE_DO_NOT_USE";
    /** AUTO_GRATUITY - @desc Auto gratuity service charge type */
    CatalogServiceChargeType[CatalogServiceChargeType["AUTO_GRATUITY"] = 1] = "AUTO_GRATUITY";
    /** CUSTOM - @desc Custom service charge type */
    CatalogServiceChargeType[CatalogServiceChargeType["CUSTOM"] = 2] = "CUSTOM";
    /** CARD_SURCHARGE - @desc Card surcharge type */
    CatalogServiceChargeType[CatalogServiceChargeType["CARD_SURCHARGE"] = 3] = "CARD_SURCHARGE";
    CatalogServiceChargeType[CatalogServiceChargeType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogServiceChargeType || (CatalogServiceChargeType = {}));
/**
 * --
 * @desc Determines service charge calculation phase
 * --
 */
export var CatalogServiceChargeCalculationPhase;
(function (CatalogServiceChargeCalculationPhase) {
    /** SURCHARGE_PHASE - @desc The service charge is calculated based on the subtotal before taxes. */
    CatalogServiceChargeCalculationPhase[CatalogServiceChargeCalculationPhase["SURCHARGE_PHASE"] = 6] = "SURCHARGE_PHASE";
    /** SURCHARGE_TOTAL_PHASE - @desc The service charge is calculated based on the total after taxes. */
    CatalogServiceChargeCalculationPhase[CatalogServiceChargeCalculationPhase["SURCHARGE_TOTAL_PHASE"] = 7] = "SURCHARGE_TOTAL_PHASE";
    /** SURCHARGE_APPORTIONED_PHASE - @desc The service charge is calculated as a compounding adjustment after any discounts and before any tax considerations. */
    CatalogServiceChargeCalculationPhase[CatalogServiceChargeCalculationPhase["SURCHARGE_APPORTIONED_PHASE"] = 8] = "SURCHARGE_APPORTIONED_PHASE";
    /** CARD_SURCHARGE_PHASE - @desc The service charge is calculated based on the total after taxes and other service charges are applied. */
    CatalogServiceChargeCalculationPhase[CatalogServiceChargeCalculationPhase["CARD_SURCHARGE_PHASE"] = 10] = "CARD_SURCHARGE_PHASE";
    CatalogServiceChargeCalculationPhase[CatalogServiceChargeCalculationPhase["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogServiceChargeCalculationPhase || (CatalogServiceChargeCalculationPhase = {}));
/**
 * --
 * @desc Determines service charge type
 * --
 */
export var CatalogServiceChargeAutoEnableType;
(function (CatalogServiceChargeAutoEnableType) {
    CatalogServiceChargeAutoEnableType[CatalogServiceChargeAutoEnableType["AUTO_ENABLE_TYPE_DO_NOT_USE"] = 0] = "AUTO_ENABLE_TYPE_DO_NOT_USE";
    /** MINIMUM_SEAT_COUNT - @desc Automatically applies gratuity when the minimum seat count threshold is met. `minimum_seat_count` must be set when this value is used. */
    CatalogServiceChargeAutoEnableType[CatalogServiceChargeAutoEnableType["MINIMUM_SEAT_COUNT"] = 1] = "MINIMUM_SEAT_COUNT";
    /** ALWAYS - @desc Always automatically apply gratuity. */
    CatalogServiceChargeAutoEnableType[CatalogServiceChargeAutoEnableType["ALWAYS"] = 2] = "ALWAYS";
    CatalogServiceChargeAutoEnableType[CatalogServiceChargeAutoEnableType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogServiceChargeAutoEnableType || (CatalogServiceChargeAutoEnableType = {}));
/**
 * --
 * @desc Determines service charge calculation type
 * --
 */
export var CatalogServiceChargeCalculationType;
(function (CatalogServiceChargeCalculationType) {
    /** SURCHARGE_FIXED - @desc The service charge has a fixed amount or percentage value. */
    CatalogServiceChargeCalculationType[CatalogServiceChargeCalculationType["SURCHARGE_FIXED"] = 0] = "SURCHARGE_FIXED";
    /** SURCHARGE_VARIABLE_PERCENTAGE - @desc The service charge represents a percentage-based variable amount service charge. */
    CatalogServiceChargeCalculationType[CatalogServiceChargeCalculationType["SURCHARGE_VARIABLE_PERCENTAGE"] = 1] = "SURCHARGE_VARIABLE_PERCENTAGE";
    /** SURCHARGE_VARIABLE_AMOUNT - @desc The service charge represents an amount-based variable amount service charge. */
    CatalogServiceChargeCalculationType[CatalogServiceChargeCalculationType["SURCHARGE_VARIABLE_AMOUNT"] = 2] = "SURCHARGE_VARIABLE_AMOUNT";
    CatalogServiceChargeCalculationType[CatalogServiceChargeCalculationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogServiceChargeCalculationType || (CatalogServiceChargeCalculationType = {}));
/**
 * --
 * @desc Determines service charge treatment type
 * --
 */
export var CatalogServiceChargeTreatmentType;
(function (CatalogServiceChargeTreatmentType) {
    CatalogServiceChargeTreatmentType[CatalogServiceChargeTreatmentType["SURCHARGE_TREATMENT_DO_NOT_USE"] = 0] = "SURCHARGE_TREATMENT_DO_NOT_USE";
    /** SURCHARGE_TREATMENT_LINE_ITEM - @desc The service charge should be treated as a value-holding line item */
    CatalogServiceChargeTreatmentType[CatalogServiceChargeTreatmentType["SURCHARGE_TREATMENT_LINE_ITEM"] = 1] = "SURCHARGE_TREATMENT_LINE_ITEM";
    /** SURCHARGE_TREATMENT_APPORTIONED - @desc The service charge should be apportioned toward a line item */
    CatalogServiceChargeTreatmentType[CatalogServiceChargeTreatmentType["SURCHARGE_TREATMENT_APPORTIONED"] = 2] = "SURCHARGE_TREATMENT_APPORTIONED";
    CatalogServiceChargeTreatmentType[CatalogServiceChargeTreatmentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogServiceChargeTreatmentType || (CatalogServiceChargeTreatmentType = {}));
/**
 * --
 * @desc Determines the billing cadence of a [Subscription](entity:Subscription)
 * --
 */
export var SubscriptionCadence;
(function (SubscriptionCadence) {
    SubscriptionCadence[SubscriptionCadence["SUBSCRIPTION_CADENCE_DO_NOT_USE"] = 0] = "SUBSCRIPTION_CADENCE_DO_NOT_USE";
    /** DAILY - @desc Once per day */
    SubscriptionCadence[SubscriptionCadence["DAILY"] = 1] = "DAILY";
    /** WEEKLY - @desc Once per week */
    SubscriptionCadence[SubscriptionCadence["WEEKLY"] = 2] = "WEEKLY";
    /** EVERY_TWO_WEEKS - @desc Every two weeks */
    SubscriptionCadence[SubscriptionCadence["EVERY_TWO_WEEKS"] = 3] = "EVERY_TWO_WEEKS";
    /** THIRTY_DAYS - @desc Once every 30 days */
    SubscriptionCadence[SubscriptionCadence["THIRTY_DAYS"] = 4] = "THIRTY_DAYS";
    /** SIXTY_DAYS - @desc Once every 60 days */
    SubscriptionCadence[SubscriptionCadence["SIXTY_DAYS"] = 5] = "SIXTY_DAYS";
    /** NINETY_DAYS - @desc Once every 90 days */
    SubscriptionCadence[SubscriptionCadence["NINETY_DAYS"] = 6] = "NINETY_DAYS";
    /** MONTHLY - @desc Once per month */
    SubscriptionCadence[SubscriptionCadence["MONTHLY"] = 7] = "MONTHLY";
    /** EVERY_TWO_MONTHS - @desc Once every two months */
    SubscriptionCadence[SubscriptionCadence["EVERY_TWO_MONTHS"] = 8] = "EVERY_TWO_MONTHS";
    /** QUARTERLY - @desc Once every three months */
    SubscriptionCadence[SubscriptionCadence["QUARTERLY"] = 9] = "QUARTERLY";
    /** EVERY_FOUR_MONTHS - @desc Once every four months */
    SubscriptionCadence[SubscriptionCadence["EVERY_FOUR_MONTHS"] = 10] = "EVERY_FOUR_MONTHS";
    /** EVERY_SIX_MONTHS - @desc Once every six months */
    SubscriptionCadence[SubscriptionCadence["EVERY_SIX_MONTHS"] = 11] = "EVERY_SIX_MONTHS";
    /** ANNUAL - @desc Once per year */
    SubscriptionCadence[SubscriptionCadence["ANNUAL"] = 12] = "ANNUAL";
    /** EVERY_TWO_YEARS - @desc Once every two years */
    SubscriptionCadence[SubscriptionCadence["EVERY_TWO_YEARS"] = 13] = "EVERY_TWO_YEARS";
    SubscriptionCadence[SubscriptionCadence["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SubscriptionCadence || (SubscriptionCadence = {}));
/**
 * --
 * @desc Determines the pricing of a [Subscription](entity:Subscription)
 * --
 */
export var SubscriptionPricingType;
(function (SubscriptionPricingType) {
    SubscriptionPricingType[SubscriptionPricingType["SUBSCRIPTION_PRICING_DO_NOT_USE"] = 0] = "SUBSCRIPTION_PRICING_DO_NOT_USE";
    /** STATIC - @desc Static pricing */
    SubscriptionPricingType[SubscriptionPricingType["STATIC"] = 1] = "STATIC";
    /** RELATIVE - @desc Relative pricing */
    SubscriptionPricingType[SubscriptionPricingType["RELATIVE"] = 2] = "RELATIVE";
    SubscriptionPricingType[SubscriptionPricingType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SubscriptionPricingType || (SubscriptionPricingType = {}));
/**
 * --
 * @desc Determines the type of checkout link and affects legal copy on checkout page.
 * --
 */
export var CheckoutLinkType;
(function (CheckoutLinkType) {
    CheckoutLinkType[CheckoutLinkType["CHECKOUT_LINK_TYPE_DO_NOT_USE"] = 0] = "CHECKOUT_LINK_TYPE_DO_NOT_USE";
    /** PAYMENT_LINK - @desc Link is used for a single non item based payment */
    CheckoutLinkType[CheckoutLinkType["PAYMENT_LINK"] = 1] = "PAYMENT_LINK";
    /** DONATION_LINK - @desc Link is used for donation style payments, defines legal copy */
    CheckoutLinkType[CheckoutLinkType["DONATION_LINK"] = 2] = "DONATION_LINK";
    /** ITEM_LINK - @desc Link is used for item based payments */
    CheckoutLinkType[CheckoutLinkType["ITEM_LINK"] = 3] = "ITEM_LINK";
    /** CLASS_LINK - @desc Link is used for paying for classes */
    CheckoutLinkType[CheckoutLinkType["CLASS_LINK"] = 4] = "CLASS_LINK";
    /** SERVICE_LINK - @desc Link is used for providing services */
    CheckoutLinkType[CheckoutLinkType["SERVICE_LINK"] = 5] = "SERVICE_LINK";
    CheckoutLinkType[CheckoutLinkType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CheckoutLinkType || (CheckoutLinkType = {}));
/**
 * --
 * @desc Object types to inline under their respective parent object in certain connect v2 responses
 * --
 */
export var InlineTypes;
(function (InlineTypes) {
    InlineTypes[InlineTypes["INLINE_NONE"] = 0] = "INLINE_NONE";
    InlineTypes[InlineTypes["INLINE_VARIATIONS"] = 1] = "INLINE_VARIATIONS";
    InlineTypes[InlineTypes["INLINE_ALL"] = 2] = "INLINE_ALL";
    InlineTypes[InlineTypes["INLINE_ITEM_TAX_IDS"] = 3] = "INLINE_ITEM_TAX_IDS";
    InlineTypes[InlineTypes["INLINE_ITEM_LEGACY_TAX_IDS"] = 4] = "INLINE_ITEM_LEGACY_TAX_IDS";
    InlineTypes[InlineTypes["INLINE_ITEM_MODIFIER_LIST_INFO"] = 5] = "INLINE_ITEM_MODIFIER_LIST_INFO";
    InlineTypes[InlineTypes["INLINE_SURCHARGE_LEGACY_TAX_IDS"] = 6] = "INLINE_SURCHARGE_LEGACY_TAX_IDS";
    InlineTypes[InlineTypes["INLINE_EVENTS"] = 7] = "INLINE_EVENTS";
    InlineTypes[InlineTypes["INLINE_QUICK_AMOUNTS"] = 8] = "INLINE_QUICK_AMOUNTS";
    InlineTypes[InlineTypes["INLINE_SUBSCRIPTION_PHASES"] = 9] = "INLINE_SUBSCRIPTION_PHASES";
    InlineTypes[InlineTypes["INLINE_CHECKOUT_LINK_LINE_ITEMS"] = 10] = "INLINE_CHECKOUT_LINK_LINE_ITEMS";
    InlineTypes[InlineTypes["INLINE_CHECKOUT_LINK_CUSTOM_FIELDS"] = 11] = "INLINE_CHECKOUT_LINK_CUSTOM_FIELDS";
    InlineTypes[InlineTypes["INLINE_CUSTOM_ATTRIBUTE_SELECTIONS"] = 12] = "INLINE_CUSTOM_ATTRIBUTE_SELECTIONS";
    InlineTypes[InlineTypes["INLINE_COGS_IDS"] = 13] = "INLINE_COGS_IDS";
    /** INLINE_SUBSCRIPTION_PLAN_IDS - Only renamed this field, it seemed fine */
    InlineTypes[InlineTypes["INLINE_SUBSCRIPTION_PLAN_IDS"] = 14] = "INLINE_SUBSCRIPTION_PLAN_IDS";
    /** INLINE_SUBSCRIPTION_PLAN_VARIATIONS - Only renamed this field, it seemed fine */
    InlineTypes[InlineTypes["INLINE_SUBSCRIPTION_PLAN_VARIATIONS"] = 15] = "INLINE_SUBSCRIPTION_PLAN_VARIATIONS";
    InlineTypes[InlineTypes["INLINE_ITEM_VARIATION_VENDOR_INFOS"] = 16] = "INLINE_ITEM_VARIATION_VENDOR_INFOS";
    InlineTypes[InlineTypes["INLINE_CREDIT_REDEMPTION_POLICIES"] = 17] = "INLINE_CREDIT_REDEMPTION_POLICIES";
    InlineTypes[InlineTypes["INLINE_PRICING_OBJECTS_FOR_ABACUS"] = 18] = "INLINE_PRICING_OBJECTS_FOR_ABACUS";
    InlineTypes[InlineTypes["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(InlineTypes || (InlineTypes = {}));
/**
 * --
 * @desc Location types of an event
 * --
 */
export var EventLocationType;
(function (EventLocationType) {
    EventLocationType[EventLocationType["EVENT_LOCATION_TYPE_DO_NOT_USE"] = 0] = "EVENT_LOCATION_TYPE_DO_NOT_USE";
    /** IN_PERSON - @desc The event is delivered in person */
    EventLocationType[EventLocationType["IN_PERSON"] = 1] = "IN_PERSON";
    /** ONLINE - @desc The event is delivered online */
    EventLocationType[EventLocationType["ONLINE"] = 2] = "ONLINE";
    EventLocationType[EventLocationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EventLocationType || (EventLocationType = {}));
/**
 * --
 * @desc Supported nullable attributes that can be used in a query expression to
 * return items or item variations when a nullable attribute value on the items
 * or item variations matches the associated query expression or when the nullable
 * attribute is not assigned to the items or item variations.
 * --
 */
export var NullableField;
(function (NullableField) {
    NullableField[NullableField["NULLABLE_FIELD_DO_NOT_USE"] = 0] = "NULLABLE_FIELD_DO_NOT_USE";
    /** VENDOR_TOKEN - @desc `VENDOR_ID` can be null when used as a search attribute to return catalog objects with undefined `VENDOR_ID`. */
    NullableField[NullableField["VENDOR_TOKEN"] = 1] = "VENDOR_TOKEN";
    NullableField[NullableField["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(NullableField || (NullableField = {}));
/**
 * --
 * @desc Defines supported stock levels of the item inventory.
 * --
 */
export var StockLevel;
(function (StockLevel) {
    StockLevel[StockLevel["STOCK_LEVEL_DO_NOT_USE"] = 0] = "STOCK_LEVEL_DO_NOT_USE";
    /** OUT - @desc The item inventory is empty. */
    StockLevel[StockLevel["OUT"] = 1] = "OUT";
    /** LOW - @desc The item inventory is low. */
    StockLevel[StockLevel["LOW"] = 2] = "LOW";
    StockLevel[StockLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StockLevel || (StockLevel = {}));
/**
 * --
 * @desc Indicates what Square Online fulfillment types the service charge should apply to. Only valid for internal
 * usage by Square Online.
 * --
 */
export var CatalogServiceChargeEcomFulfillmentType;
(function (CatalogServiceChargeEcomFulfillmentType) {
    CatalogServiceChargeEcomFulfillmentType[CatalogServiceChargeEcomFulfillmentType["ECOM_FULFILLMENT_TYPE_DO_NOT_USE"] = 0] = "ECOM_FULFILLMENT_TYPE_DO_NOT_USE";
    CatalogServiceChargeEcomFulfillmentType[CatalogServiceChargeEcomFulfillmentType["ECOM_FULFILLMENT_TYPE_PICKUP"] = 1] = "ECOM_FULFILLMENT_TYPE_PICKUP";
    CatalogServiceChargeEcomFulfillmentType[CatalogServiceChargeEcomFulfillmentType["ECOM_FULFILLMENT_TYPE_DELIVERY"] = 2] = "ECOM_FULFILLMENT_TYPE_DELIVERY";
    CatalogServiceChargeEcomFulfillmentType[CatalogServiceChargeEcomFulfillmentType["ECOM_FULFILLMENT_TYPE_DINE_IN"] = 3] = "ECOM_FULFILLMENT_TYPE_DINE_IN";
    CatalogServiceChargeEcomFulfillmentType[CatalogServiceChargeEcomFulfillmentType["ECOM_FULFILLMENT_TYPE_SHIPPING"] = 4] = "ECOM_FULFILLMENT_TYPE_SHIPPING";
    CatalogServiceChargeEcomFulfillmentType[CatalogServiceChargeEcomFulfillmentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogServiceChargeEcomFulfillmentType || (CatalogServiceChargeEcomFulfillmentType = {}));
/**
 * --
 * @desc Indicates what Order source the pricing rule should apply to.
 * --
 */
export var CatalogPricingSource;
(function (CatalogPricingSource) {
    CatalogPricingSource[CatalogPricingSource["PRICING_SOURCE_DO_NOT_USE"] = 0] = "PRICING_SOURCE_DO_NOT_USE";
    CatalogPricingSource[CatalogPricingSource["SQUARE_ONLINE"] = 1] = "SQUARE_ONLINE";
    CatalogPricingSource[CatalogPricingSource["GIFT_CARDS"] = 2] = "GIFT_CARDS";
    CatalogPricingSource[CatalogPricingSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogPricingSource || (CatalogPricingSource = {}));
/**
 * --
 * @desc Indicates what payment type the pricing rule should apply to.
 * --
 */
export var PricingRulePaymentType;
(function (PricingRulePaymentType) {
    PricingRulePaymentType[PricingRulePaymentType["PAYMENT_TYPE_DO_NOT_USE"] = 0] = "PAYMENT_TYPE_DO_NOT_USE";
    PricingRulePaymentType[PricingRulePaymentType["CARD"] = 1] = "CARD";
    PricingRulePaymentType[PricingRulePaymentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PricingRulePaymentType || (PricingRulePaymentType = {}));
/**
 * --
 * @desc Enum used by [CatalogMenu](entity:CatalogMenu), [CatalogMenuGroup](entity:CatalogMenuGroup), and [CatalogTag](entity:CatalogTag).
 * --
 */
export var CatalogProductName;
(function (CatalogProductName) {
    CatalogProductName[CatalogProductName["PRODUCT_NAME_UNKNOWN"] = 0] = "PRODUCT_NAME_UNKNOWN";
    CatalogProductName[CatalogProductName["PRODUCT_NAME_RESTAURANTS"] = 1] = "PRODUCT_NAME_RESTAURANTS";
    CatalogProductName[CatalogProductName["PRODUCT_NAME_RETAIL"] = 2] = "PRODUCT_NAME_RETAIL";
    CatalogProductName[CatalogProductName["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogProductName || (CatalogProductName = {}));
/**
 * --
 * @desc Enum used by [CatalogPlaceholder](entity:CatalogPlaceholder).
 * --
 */
export var CatalogPlaceholderType;
(function (CatalogPlaceholderType) {
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_UNKNOWN"] = 0] = "PLACEHOLDER_TYPE_UNKNOWN";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_DISCOUNTS_CATEGORY"] = 1] = "PLACEHOLDER_TYPE_DISCOUNTS_CATEGORY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_REWARDS_FINDER"] = 2] = "PLACEHOLDER_TYPE_REWARDS_FINDER";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ALL_ITEMS"] = 3] = "PLACEHOLDER_TYPE_ALL_ITEMS";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_COUPONS_FINDER"] = 4] = "PLACEHOLDER_TYPE_COUPONS_FINDER";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_GIFT_CARDS_CATEGORY"] = 5] = "PLACEHOLDER_TYPE_GIFT_CARDS_CATEGORY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CUSTOM_AMOUNT"] = 6] = "PLACEHOLDER_TYPE_CUSTOM_AMOUNT";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CALCULATOR"] = 7] = "PLACEHOLDER_TYPE_CALCULATOR";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_2"] = 8] = "PLACEHOLDER_TYPE_QUANTITY_2";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_3"] = 9] = "PLACEHOLDER_TYPE_QUANTITY_3";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_4"] = 10] = "PLACEHOLDER_TYPE_QUANTITY_4";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_5"] = 11] = "PLACEHOLDER_TYPE_QUANTITY_5";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_6"] = 12] = "PLACEHOLDER_TYPE_QUANTITY_6";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_7"] = 13] = "PLACEHOLDER_TYPE_QUANTITY_7";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_8"] = 14] = "PLACEHOLDER_TYPE_QUANTITY_8";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_QUANTITY_9"] = 15] = "PLACEHOLDER_TYPE_QUANTITY_9";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CUSTOM_QUANTITY"] = 16] = "PLACEHOLDER_TYPE_CUSTOM_QUANTITY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CLOCK_IN_OUT"] = 17] = "PLACEHOLDER_TYPE_CLOCK_IN_OUT";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ISSUE_REFUND"] = 18] = "PLACEHOLDER_TYPE_ISSUE_REFUND";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ADJUST_TIP"] = 19] = "PLACEHOLDER_TYPE_ADJUST_TIP";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_COMP_VOID"] = 20] = "PLACEHOLDER_TYPE_COMP_VOID";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ADD_CUSTOMER"] = 21] = "PLACEHOLDER_TYPE_ADD_CUSTOMER";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_EDIT_TICKET_NAME_AND_NOTES"] = 22] = "PLACEHOLDER_TYPE_EDIT_TICKET_NAME_AND_NOTES";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_VOID_TICKET"] = 23] = "PLACEHOLDER_TYPE_VOID_TICKET";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_COMP_TICKET"] = 24] = "PLACEHOLDER_TYPE_COMP_TICKET";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_SPLIT_TICKET"] = 25] = "PLACEHOLDER_TYPE_SPLIT_TICKET";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_MOVE_TICKET"] = 26] = "PLACEHOLDER_TYPE_MOVE_TICKET";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ASSIGN_TICKET"] = 27] = "PLACEHOLDER_TYPE_ASSIGN_TICKET";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_EDIT_TICKET_SEATS"] = 28] = "PLACEHOLDER_TYPE_EDIT_TICKET_SEATS";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_EDIT_TICKET_ALLERGY"] = 29] = "PLACEHOLDER_TYPE_EDIT_TICKET_ALLERGY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CUSTOM_DISCOUNT"] = 30] = "PLACEHOLDER_TYPE_CUSTOM_DISCOUNT";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_DINING_OPTION_CATEGORY"] = 31] = "PLACEHOLDER_TYPE_DINING_OPTION_CATEGORY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ORDER_HISTORY"] = 32] = "PLACEHOLDER_TYPE_ORDER_HISTORY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CUSTOM_GIFT_CARD"] = 33] = "PLACEHOLDER_TYPE_CUSTOM_GIFT_CARD";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_OPEN_ALL_DRAWERS"] = 34] = "PLACEHOLDER_TYPE_OPEN_ALL_DRAWERS";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_PAY_IN_OUT"] = 35] = "PLACEHOLDER_TYPE_PAY_IN_OUT";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_LINE"] = 36] = "PLACEHOLDER_TYPE_LINE";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_SHAPE"] = 37] = "PLACEHOLDER_TYPE_SHAPE";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_TEXT_LABEL"] = 38] = "PLACEHOLDER_TYPE_TEXT_LABEL";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_AUTO_GRATUITY"] = 39] = "PLACEHOLDER_TYPE_AUTO_GRATUITY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ALL_SERVICES"] = 40] = "PLACEHOLDER_TYPE_ALL_SERVICES";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ALL_ITEMS_AND_SERVICES"] = 41] = "PLACEHOLDER_TYPE_ALL_ITEMS_AND_SERVICES";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_SERVICE_CHARGES"] = 42] = "PLACEHOLDER_TYPE_SERVICE_CHARGES";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ALL_CUSTOMERS"] = 43] = "PLACEHOLDER_TYPE_ALL_CUSTOMERS";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ALL_CARTS"] = 44] = "PLACEHOLDER_TYPE_ALL_CARTS";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CREATE_ITEM"] = 45] = "PLACEHOLDER_TYPE_CREATE_ITEM";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_EXCHANGES"] = 46] = "PLACEHOLDER_TYPE_EXCHANGES";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_NOTIFY_WHEN_READY"] = 48] = "PLACEHOLDER_TYPE_NOTIFY_WHEN_READY";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_ALL_CREDIT_PACKAGES"] = 49] = "PLACEHOLDER_TYPE_ALL_CREDIT_PACKAGES";
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_CLEAR_ALL_CART_ITEMS"] = 50] = "PLACEHOLDER_TYPE_CLEAR_ALL_CART_ITEMS";
    /** PLACEHOLDER_TYPE_COUNT - Must be last value */
    CatalogPlaceholderType[CatalogPlaceholderType["PLACEHOLDER_TYPE_COUNT"] = 51] = "PLACEHOLDER_TYPE_COUNT";
    CatalogPlaceholderType[CatalogPlaceholderType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogPlaceholderType || (CatalogPlaceholderType = {}));
/**
 * --
 * @desc Enum used by [CatalogPage](entity:CatalogPage) and [CatalogConfiguration](entity:CatalogConfiguration).
 * --
 */
export var CatalogPageLayout;
(function (CatalogPageLayout) {
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_UNKNOWN"] = 0] = "PAGE_LAYOUT_UNKNOWN";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_FLEXIBLE"] = 1] = "PAGE_LAYOUT_FLEXIBLE";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_IMAGE_TILES_5X5"] = 2] = "PAGE_LAYOUT_IMAGE_TILES_5X5";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_TEXT_TILES_3X9"] = 3] = "PAGE_LAYOUT_TEXT_TILES_3X9";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_IMAGE_TEXT_TILES_8X8"] = 4] = "PAGE_LAYOUT_IMAGE_TEXT_TILES_8X8";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_IMAGE_TEXT_TILES_12X11"] = 5] = "PAGE_LAYOUT_IMAGE_TEXT_TILES_12X11";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_IMAGE_TEXT_TILES_12X8"] = 6] = "PAGE_LAYOUT_IMAGE_TEXT_TILES_12X8";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_IMAGE_TEXT_TILES_16X11"] = 7] = "PAGE_LAYOUT_IMAGE_TEXT_TILES_16X11";
    CatalogPageLayout[CatalogPageLayout["PAGE_LAYOUT_IMAGE_TILES_2X10"] = 8] = "PAGE_LAYOUT_IMAGE_TILES_2X10";
    CatalogPageLayout[CatalogPageLayout["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogPageLayout || (CatalogPageLayout = {}));
/**
 * --
 * @desc Enum used by [CatalogTag](entity:CatalogTag).
 * --
 */
export var CatalogTagType;
(function (CatalogTagType) {
    CatalogTagType[CatalogTagType["TAG_TYPE_DEFAULT"] = 0] = "TAG_TYPE_DEFAULT";
    CatalogTagType[CatalogTagType["TAG_TYPE_MENU_GROUP"] = 1] = "TAG_TYPE_MENU_GROUP";
    CatalogTagType[CatalogTagType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogTagType || (CatalogTagType = {}));
/**
 * --
 * @desc Unit of weight used to measure a quantity.
 * --
 */
export var CatalogItemVariationWeightUnit;
(function (CatalogItemVariationWeightUnit) {
    CatalogItemVariationWeightUnit[CatalogItemVariationWeightUnit["INVALID_WEIGHT"] = 0] = "INVALID_WEIGHT";
    /**
     * IMPERIAL_POUND - --
     * @desc The weight is measured in pounds.
     * --
     */
    CatalogItemVariationWeightUnit[CatalogItemVariationWeightUnit["IMPERIAL_POUND"] = 1] = "IMPERIAL_POUND";
    /**
     * METRIC_KILOGRAM - --
     * @desc The weight is measured in kilograms.
     * --
     */
    CatalogItemVariationWeightUnit[CatalogItemVariationWeightUnit["METRIC_KILOGRAM"] = 2] = "METRIC_KILOGRAM";
    CatalogItemVariationWeightUnit[CatalogItemVariationWeightUnit["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogItemVariationWeightUnit || (CatalogItemVariationWeightUnit = {}));
/**
 * --
 * @desc The product set will match the specified line item types.
 * --
 */
export var CatalogProductSetLineItemType;
(function (CatalogProductSetLineItemType) {
    CatalogProductSetLineItemType[CatalogProductSetLineItemType["PRODUCT_SET_LINE_ITEM_TYPE_DO_NOT_USE"] = 0] = "PRODUCT_SET_LINE_ITEM_TYPE_DO_NOT_USE";
    CatalogProductSetLineItemType[CatalogProductSetLineItemType["PRODUCT_SET_LINE_ITEM_TYPE_GIFT_CARD"] = 1] = "PRODUCT_SET_LINE_ITEM_TYPE_GIFT_CARD";
    CatalogProductSetLineItemType[CatalogProductSetLineItemType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogProductSetLineItemType || (CatalogProductSetLineItemType = {}));
/** @desc possible type of a composition */
export var CompositionType;
(function (CompositionType) {
    CompositionType[CompositionType["INVALID_COMPOSITION_TYPE"] = 0] = "INVALID_COMPOSITION_TYPE";
    /** BUNDLE - @desc The composition is a fixed bundle of other variations with a fixed quantity for each variation. */
    CompositionType[CompositionType["BUNDLE"] = 1] = "BUNDLE";
    /**
     * STOCK_CONVERSION - @desc The composition is a conversion from another variation on the same item.
     * Sales of this variation will decrement the stock of the target variation according to the stock conversion ratio.
     */
    CompositionType[CompositionType["STOCK_CONVERSION"] = 2] = "STOCK_CONVERSION";
    CompositionType[CompositionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CompositionType || (CompositionType = {}));
/** @desc type of void reason used by appointments for various void scenarios */
export var CatalogVoidReasonAppointmentsType;
(function (CatalogVoidReasonAppointmentsType) {
    CatalogVoidReasonAppointmentsType[CatalogVoidReasonAppointmentsType["APPTS_TYPE_NONE"] = 0] = "APPTS_TYPE_NONE";
    /** APPTS_TYPE_CANCEL - @desc The void reason is used for cancellations involving a refund. */
    CatalogVoidReasonAppointmentsType[CatalogVoidReasonAppointmentsType["APPTS_TYPE_CANCEL"] = 1] = "APPTS_TYPE_CANCEL";
    /** APPTS_TYPE_NO_SHOW - @desc The void reason is used for a no-show cancellation involving a cancellation fee or deposit forfeiture. */
    CatalogVoidReasonAppointmentsType[CatalogVoidReasonAppointmentsType["APPTS_TYPE_NO_SHOW"] = 2] = "APPTS_TYPE_NO_SHOW";
    CatalogVoidReasonAppointmentsType[CatalogVoidReasonAppointmentsType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogVoidReasonAppointmentsType || (CatalogVoidReasonAppointmentsType = {}));
export var CatalogTicketGroupNamingMethod;
(function (CatalogTicketGroupNamingMethod) {
    /** TICKET_GROUP_DO_NOT_USE - Note: numbering is different than in internal APIs */
    CatalogTicketGroupNamingMethod[CatalogTicketGroupNamingMethod["TICKET_GROUP_DO_NOT_USE"] = 0] = "TICKET_GROUP_DO_NOT_USE";
    CatalogTicketGroupNamingMethod[CatalogTicketGroupNamingMethod["TICKET_GROUP_AUTOMATIC_NUMBERING"] = 1] = "TICKET_GROUP_AUTOMATIC_NUMBERING";
    CatalogTicketGroupNamingMethod[CatalogTicketGroupNamingMethod["TICKET_GROUP_MANUAL_NUMBERING"] = 2] = "TICKET_GROUP_MANUAL_NUMBERING";
    CatalogTicketGroupNamingMethod[CatalogTicketGroupNamingMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogTicketGroupNamingMethod || (CatalogTicketGroupNamingMethod = {}));
export var CatalogTicketGroupPrefixTableNames;
(function (CatalogTicketGroupPrefixTableNames) {
    CatalogTicketGroupPrefixTableNames[CatalogTicketGroupPrefixTableNames["TICKET_GROUP_PREFIX_TABLE_NAMES_DO_NOT_USE"] = 0] = "TICKET_GROUP_PREFIX_TABLE_NAMES_DO_NOT_USE";
    CatalogTicketGroupPrefixTableNames[CatalogTicketGroupPrefixTableNames["TICKET_GROUP_PREFIX_TABLE_NAMES_NONE"] = 1] = "TICKET_GROUP_PREFIX_TABLE_NAMES_NONE";
    CatalogTicketGroupPrefixTableNames[CatalogTicketGroupPrefixTableNames["TICKET_GROUP_PREFIX_TABLE_NAMES_SECTION"] = 2] = "TICKET_GROUP_PREFIX_TABLE_NAMES_SECTION";
    CatalogTicketGroupPrefixTableNames[CatalogTicketGroupPrefixTableNames["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogTicketGroupPrefixTableNames || (CatalogTicketGroupPrefixTableNames = {}));
export var CatalogFloorPlanTileShape;
(function (CatalogFloorPlanTileShape) {
    /** FLOOR_PLAN_TILE_SHAPE_DO_NOT_USE - Note: numbering is different than in internal APIs */
    CatalogFloorPlanTileShape[CatalogFloorPlanTileShape["FLOOR_PLAN_TILE_SHAPE_DO_NOT_USE"] = 0] = "FLOOR_PLAN_TILE_SHAPE_DO_NOT_USE";
    CatalogFloorPlanTileShape[CatalogFloorPlanTileShape["FLOOR_PLAN_TILE_SHAPE_UNKNOWN"] = 1] = "FLOOR_PLAN_TILE_SHAPE_UNKNOWN";
    CatalogFloorPlanTileShape[CatalogFloorPlanTileShape["FLOOR_PLAN_TILE_SHAPE_RECTANGULAR"] = 2] = "FLOOR_PLAN_TILE_SHAPE_RECTANGULAR";
    CatalogFloorPlanTileShape[CatalogFloorPlanTileShape["FLOOR_PLAN_TILE_SHAPE_ROUNDED_RECTANGLE"] = 3] = "FLOOR_PLAN_TILE_SHAPE_ROUNDED_RECTANGLE";
    CatalogFloorPlanTileShape[CatalogFloorPlanTileShape["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogFloorPlanTileShape || (CatalogFloorPlanTileShape = {}));
/** @desc Defines the type of `CatalogModifierList`. */
export var CatalogModifierListModifierType;
(function (CatalogModifierListModifierType) {
    /** LIST - @desc The `CatalogModifierList` instance is a non-empty list of non text-based modifiers. */
    CatalogModifierListModifierType[CatalogModifierListModifierType["LIST"] = 0] = "LIST";
    /** TEXT - @desc The `CatalogModifierList` instance is a single text-based modifier. */
    CatalogModifierListModifierType[CatalogModifierListModifierType["TEXT"] = 1] = "TEXT";
    CatalogModifierListModifierType[CatalogModifierListModifierType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogModifierListModifierType || (CatalogModifierListModifierType = {}));
/**
 * --
 * @desc Basis for cost of materials required to perform a service
 * --
 */
export var ServiceCostType;
(function (ServiceCostType) {
    /** FLAT_PRICING - @desc Cost is a flat price, not dependent on (but must be less than) service price */
    ServiceCostType[ServiceCostType["FLAT_PRICING"] = 0] = "FLAT_PRICING";
    /** PERCENT_PRICING - @desc Cost is a percentage of service price */
    ServiceCostType[ServiceCostType["PERCENT_PRICING"] = 1] = "PERCENT_PRICING";
    ServiceCostType[ServiceCostType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ServiceCostType || (ServiceCostType = {}));
/** @desc Supported values for the sellable filter */
export var SellableValue;
(function (SellableValue) {
    SellableValue[SellableValue["SELLABLE_VALUE_DO_NOT_USE"] = 0] = "SELLABLE_VALUE_DO_NOT_USE";
    /** SELLABLE - @desc Only include sellable variations */
    SellableValue[SellableValue["SELLABLE"] = 1] = "SELLABLE";
    /** NON_SELLABLE - @desc Only include non-sellable variations */
    SellableValue[SellableValue["NON_SELLABLE"] = 2] = "NON_SELLABLE";
    SellableValue[SellableValue["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellableValue || (SellableValue = {}));
/** @desc Supported values for the stockable filter */
export var StockableValue;
(function (StockableValue) {
    StockableValue[StockableValue["STOCKABLE_VALUE_DO_NOT_USE"] = 0] = "STOCKABLE_VALUE_DO_NOT_USE";
    /** STOCKABLE - @desc Only include stockable variations */
    StockableValue[StockableValue["STOCKABLE"] = 1] = "STOCKABLE";
    /** NON_STOCKABLE - @desc Only include non-stockable variations */
    StockableValue[StockableValue["NON_STOCKABLE"] = 2] = "NON_STOCKABLE";
    StockableValue[StockableValue["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StockableValue || (StockableValue = {}));
export var Subscriptions_Tenant;
(function (Subscriptions_Tenant) {
    Subscriptions_Tenant[Subscriptions_Tenant["SUBSCRIPTION_TENANT_DO_NOT_USE"] = 0] = "SUBSCRIPTION_TENANT_DO_NOT_USE";
    /**
     * BUYER - --
     * @desc Default tenant for all subscription plans
     * --
     */
    Subscriptions_Tenant[Subscriptions_Tenant["BUYER"] = 1] = "BUYER";
    /**
     * APPOINTMENTS_MEMBERSHIP - --
     * @desc Used to denote if a subscription plan is a membership plan. Owned by the appointments team.
     * --
     */
    Subscriptions_Tenant[Subscriptions_Tenant["APPOINTMENTS_MEMBERSHIP"] = 2] = "APPOINTMENTS_MEMBERSHIP";
    Subscriptions_Tenant[Subscriptions_Tenant["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Subscriptions_Tenant || (Subscriptions_Tenant = {}));
function createBaseSubscriptions() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.Subscriptions" };
}
export const Subscriptions = {
    $type: "squareup.connect.v2.merchant_catalog.resources.Subscriptions",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Subscriptions.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubscriptions();
        return message;
    },
};
